// extracted by mini-css-extract-plugin
export var option = "_df-0";
export var optionCard = "_df-f";
export var optionContent = "_df-g";
export var optionIcon = "_df-i";
export var optionIconBox = "_df-h";
export var optionLabel = "_df-j";
export var optionPill = "_df-m";
export var optionPillBadge = "_df-p";
export var optionPillIcon = "_df-n";
export var optionPillLabel = "_df-o";
export var optionRadio = "_df-k";
export var optionRadioInner = "_df-l";
export var optionReveal = "_df-2";
export var optionRevealDelay0 = "_df-3";
export var optionRevealDelay1 = "_df-4";
export var optionRevealDelay10 = "_df-d";
export var optionRevealDelay11 = "_df-e";
export var optionRevealDelay2 = "_df-5";
export var optionRevealDelay3 = "_df-6";
export var optionRevealDelay4 = "_df-7";
export var optionRevealDelay5 = "_df-8";
export var optionRevealDelay6 = "_df-9";
export var optionRevealDelay7 = "_df-a";
export var optionRevealDelay8 = "_df-b";
export var optionRevealDelay9 = "_df-c";
export var optionSelected = "_df-1";